import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { FileViewer } from 'libs/rendering';
// TODO: Move Panel / LargePanel to /components?
import { CadViewerWrapper } from 'libs/rendering/gltf/viewer.styled';
import { Header } from 'libs/rendering/components/header';
import LargePanel from 'libs/rendering/gltf/components/largePanel/largePanel';
import DocumentHead from 'legacyComponents/documentHead';

import { useAppManager, useClientStore, useRouterStore } from 'apps/hooks';
import { useViewerControl } from 'libs/rendering/gltf/hooks';
import { useChatControl } from 'libs/rendering/hooks';

import { ContextAppManager } from 'apps/context/appManager';
import { ContextManagerProvider } from 'apps/context/hooks';
import FullScreenLoading from 'apps/share/blocks/fullScreenLoading';
import RFQAppManager from 'apps/rfq/appManager';
import OpenRFQ from 'apps/rfq/rfqPage/views/openRFQ';
import { FourOhFour } from 'apps/fourOhFour';

const RFQPage = observer(() => {
  const routerStore = useRouterStore();
  const clientStore = useClientStore();
  const viewerControl = useViewerControl();
  const chatControl = useChatControl();

  const rfqAppManager = useAppManager(
    RFQAppManager,
    null,
    {
      signedInProfile: clientStore?.signedInProfile,
      rfqId: routerStore.route.params.rfqId,
      viewerControl,
    },
    true,
    [routerStore.route.params.rfqId],
  );

  const contextManager = useAppManager(
    ContextAppManager,
    null,
    {
      resourceId: () => rfqAppManager.rfqApp?.intermediatorSession.shareFile.id,
      clientStore,
      viewerControl,
      contextAppHolder: rfqAppManager,
    },
    true,
    [rfqAppManager],
  );

  useEffect(() => {
    if (!chatControl.chatVisible && !routerStore.route.params.panel) {
      routerStore.navigate(
        routerStore.route.name,
        {
          ...routerStore.route.params,
          panel: 'info',
        },
        { replace: true },
      );
    }
  }, []);

  const rfqNotFound = rfqAppManager.queries.get('rfq')?.notFound;
  if (rfqNotFound) {
    return <FourOhFour type='RFQ' />;
  }

  const { rfqApp } = rfqAppManager;

  if (!rfqApp) return <FullScreenLoading />;

  const { file, partId } = rfqAppManager.viewerFile;

  return (
    <CadViewerWrapper>
      <DocumentHead title='RFQ' />
      <ContextManagerProvider value={contextManager}>
        <Header file={file} />
        <FileViewer file={file} partId={partId}>
          <LargePanel addCloseButton={false}>
            <OpenRFQ rfqApp={rfqApp} rfqManager={rfqAppManager} />
          </LargePanel>
        </FileViewer>
      </ContextManagerProvider>
    </CadViewerWrapper>
  );
});

RFQPage.propTypes = {
  routerStore: PropTypes.object,
};

export default RFQPage;
